import Tick from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Tick24PxOutlined";
import Info from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Info24PxOutlined";
import ShopFinder from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/InStore24PxOutlined";
import Delivery from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Delivery24PxOutlined";
import Returns from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ReturnsAndRefunds24PxOutlined";
import Guarantee from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/GuaranteesAndTroubleshooting24PxOutlined";
import Close24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Close24PxOutlined";

export type ListWithTickProps = {
  cssClasses?: string | undefined;
  textMessage: string;
  dataTestId?: string;
  iconType?: string;
};

const getIcon = (iconName: string) => {
  switch (iconName) {
    case "info":
      return <Info />;
    case "shop":
      return <ShopFinder />;
    case "delivery":
      return <Delivery />;
    case "returns":
      return <Returns />;
    case "guarantee":
      return <Guarantee />;
    case "close":
      return <Close24PxOutlined />;
    case "tick":
    default:
      return <Tick />;
  }
};
export const ListWithIcon = ({
  cssClasses,
  textMessage,
  dataTestId,
  iconType = "tick",
}: ListWithTickProps) => {
  return (
    <li data-testid={dataTestId} className={cssClasses}>
      {getIcon(iconType)}
      <span>{textMessage}</span>
    </li>
  );
};
